import { render, staticRenderFns } from "./dosage-report.vue?vue&type=template&id=6095bdbe&scoped=true&"
import script from "./dosage-report.vue?vue&type=script&lang=js&"
export * from "./dosage-report.vue?vue&type=script&lang=js&"
import style0 from "./dosage-report.vue?vue&type=style&index=0&id=6095bdbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095bdbe",
  null
  
)

export default component.exports